import type { GoodsReceipt, Pickup } from "../types";

export const goodsReceipts: GoodsReceipt[] = [
  {
    id: "demo-receipt-1",
    orderNumber: "2009546-004",
    supplier: "UniElektro",
    department: "Elektro",
    warehouse: "OB",
    location: "C1",
    packagesStored: 3,
    packagesTotal: 3,
    receivedAt: "31.07.2026, 07:24",
    easyTecStatus: "offen"
  },
  {
    id: "demo-receipt-2",
    orderNumber: "2009551-002",
    supplier: "Testlieferant Sanitär",
    department: "Sanitär",
    warehouse: "MZ",
    location: "A4",
    packagesStored: 1,
    packagesTotal: 2,
    receivedAt: "31.07.2026, 08:06",
    easyTecStatus: "hochgeladen"
  }
];

export const pickups: Pickup[] = [
  {
    id: "demo-pickup-1",
    orderNumber: "2009541-001",
    technician: "Testmonteur",
    warehouse: "OB",
    packageCount: 2,
    pickedUpAt: "31.07.2026, 06:58",
    signed: true
  }
];

export const warehouseName = (warehouse: "OB" | "MZ") => warehouse === "OB" ? "Oberhausen" : "Merzenich";
